/**
 * Generated by orval 🍺
 * Do not edit manually.
 * qcs control-plane
 * OpenAPI spec version: 0.1.0
 */

export type SettingValidity = typeof SettingValidity[keyof typeof SettingValidity];


export const SettingValidity = {
  valid: 'valid',
  invalid: 'invalid',
} as const;
